import { OfferCatalogueScreen } from "./offer-catalogue.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const OfferCatalogueRoutes: RouteDefinition[] = [
	{
		path: Paths.offerCatalogue.path,
		element: <OfferCatalogueScreen />,
		requiredPermissions: ["UserInAccountPermission_Nodes_ReadNodes"],
	},
];
